<template>
  <section>
    <div class="bg"></div>
    <div class="form">
      <div class="img"></div>
      <img v-if="gameLogo" :src="gameLogo" class="game-logo">
      <form ref="signUpForm">
        <div v-if="emailFormType === 'signUp'">
          <h2 v-if="group === 'bbl'">Welcome to Ford <span>Gameday Trivia</span>!</h2>
          <div class="formInput">
            <label for="signUpName" v-if="formFields.includes('name')" v-html="nameLabel">
            </label>
            <input
              v-if="!authenticationMethods.passwordFree && formFields.includes('name')"
              ref="signUpName"
              type="text"
              pattern="\S(?:\s*\S){0}.*\S"
              title="Name must be at least 2 characters"
              autocomplete="name"
              id="signUpName"
              name="name"
              v-model="signUpName"
              placeholder="Enter username..."
              required
            />
          </div>

          <div>
            <label for="signUpEmail" v-if="formFields.includes('email')">Email Address</label>
            <input
              v-if="formFields.includes('email')"
              type="email"
              autocomplete="email"
              title="Email address must be valid"
              id="signUpEmail"
              name="email"
              placeholder="Email Address"
              v-model="signUpEmail"
              required
            />
          </div>

          <div>
            <label for="signUpBirthday" v-if="formFields.includes('birthday')">Birthday</label>
            <input
              v-if="formFields.includes('birthday')"
              type="date"
              autocomplete="birthday"
              title="Birthday must be valid"
              id="signUpBirthday"
              name="birthday"
              placeholder="Birthday"
              v-model="signUpBirthday"
              required
            />
          </div>

          <div>
            <label for="signUpPassword" v-if="!authenticationMethods.passwordFree">Password</label>
            <input
              v-if="!authenticationMethods.passwordFree"
              type="password"
              autocomplete="password"
              id="signUpPassword"
              name="password"
              placeholder="Password"
              pattern="(?=.*[!@#$%^&*=]).{8,}$"
              title="Must contain at least one symbol (!@#$%^&*=) and at least 8 characters"
              v-model="signUpPassword"
              ref="newPasswordInput"
              required
            />
          </div>

          <div v-if="isOptInEnabled" class="optIn">
            <input
              type="checkbox"
              id="signUpOptIn"
              name="optIn"
              v-model="signUpOptIn"
            />
            <label for="signUpOptIn">{{ optInText }}</label>
          </div>
        </div>

        <div v-if="emailFormType === 'signIn'">
          <label for="signUpEmail" v-if="formFields.includes('email')">Email Address</label>
          <input
            v-if="formFields.includes('email')"
            type="email"
            autocomplete="email"
            title="Email address must be valid"
            id="signUpEmail"
            name="email"
            placeholder="Email Address"
            v-model="signUpEmail"
            required
          />

          <label for="signUpPassword" v-if="!authenticationMethods.passwordFree">Password</label>
          <input
            v-if="!authenticationMethods.passwordFree"
            type="password"
            autocomplete="password"
            id="signUpPassword"
            name="password"
            placeholder="Password"
            pattern="(?=.*[!@#$%^&*=]).{8,}$"
            title="Must contain at least one symbol (!@#$%^&*=) and at least 8 characters"
            v-model="signUpPassword"
            required
          />
          <div v-if="isOptInEnabled" class="optIn">
            <input
              type="checkbox"
              id="signUpOptIn"
              name="optIn"
              v-model="signUpOptIn"
            />
            <label for="signUpOptIn">{{ optInText }}</label>
          </div>
        </div>
        <div v-if="emailFormType === 'passwordForgot'">
          <label for="signUpEmail" v-if="formFields.includes('email')">Email Address</label>
          <input
            v-if="formFields.includes('email')"
            type="email"
            autocomplete="email"
            title="Email address must be valid"
            id="signUpEmail"
            name="email"
            placeholder="Email Address"
            v-model="signUpEmail"
            required
          />
        </div>
        <div v-if="emailFormType === 'passwordReset'">
          <label for="signUpPassword" v-if="!authenticationMethods.passwordFree">New Password</label>
          <input
            v-if="!authenticationMethods.passwordFree"
            type="password"
            autocomplete="password"
            id="signUpPassword"
            name="password"
            placeholder="Password"
            pattern="(?=.*[!@#$%^&*=]).{8,}$"
            title="Must contain at least one symbol (!@#$%^&*=) and at least 8 characters"
            v-model="signUpPassword"
            @blur="signUpPassword && signUpPassword.length > 0 ? $event.target.reportValidity() : null"
            ref="newPasswordInput"
            required
          />
          <label for="signUpConfirmPassword" v-if="!authenticationMethods.passwordFree">Confirm Password</label>
          <input
            v-if="!authenticationMethods.passwordFree"
            type="password"
            autocomplete="password"
            id="signUpConfirmPassword"
            name="password"
            placeholder="Password"
            pattern="(?=.*[!@#$%^&*=]).{8,}$"
            title="Must contain at least one symbol (!@#$%^&*=) and at least 8 characters"
            v-model="signUpConfirmPassword"
            @blur="signUpConfirmPassword && signUpPassword ? $event.target.reportValidity() : null"
            required
          />
        </div>
        <div v-if="signUpConfirmPasswordError" class="error-message">{{ signUpConfirmPasswordError }}</div>
        <button class="email" v-if="authenticationMethods.email || authenticationMethods.passwordFree" :disabled="processing.length > 0 || signUpConfirmPasswordError !== ''" @click.prevent="emailFormSubmit" :class="{ 'error': signUpConfirmPasswordError !== '' }">
          <span class="icon">
            <fa-icon
              :icon="processing.includes('email') || processing.includes('password') ? 'spinner' : 'envelope'"
              size="1x"
              :spin="processing.includes('email') || processing.includes('password') ? true : false"
            />
          </span>
          {{formSubmitButtonText}}
        </button>
        <span v-if="!authenticationMethods.passwordFree && emailFormType === 'signIn'"><a href="#" @click.prevent="emailFormType = 'passwordForgot'">Forgot Password?</a></span> <span v-if="!authenticationMethods.passwordFree && emailFormType !== 'signUp'"><a href="#" @click.prevent="emailFormType = 'signUp'" v-if="!externalToken" >Register</a></span> <span v-if="!authenticationMethods.passwordFree && emailFormType !== 'signIn'"><a href="#" @click.prevent="emailFormType = 'signIn'" >Login</a></span>
        <hr v-if="haveMultipleAuthMethods" />
        <div>
          <button class="facebook" v-if="authenticationMethods.facebook" :disabled="processing.length > 0" @click.prevent="socialLogin('facebook')">
            <span class="icon">
              <fa-icon
                :icon="processing === 'facebook' ? 'spinner' : ['fab', 'facebook']"
                size="1x"
                :spin="processing === 'facebook' ? true : false"
              />
            </span>
            Join with Facebook
          </button>
          <button class="google" v-if="authenticationMethods.google" :disabled="processing.length > 0" @click.prevent="socialLogin('google')">
            <span class="icon">
              <fa-icon
                :icon="processing === 'google' ? 'spinner' : ['fab', 'google']"
                size="1x"
                :spin="processing === 'google' ? true : false"
              />
            </span>
            Join with Google
          </button>
          <button class="microsoft" v-if="authenticationMethods.microsoft" :disabled="processing.length > 0" @click.prevent="socialLogin('microsoft')">
            <span class="icon">
              <fa-icon
                :icon="processing === 'microsoft' ? 'spinner' : ['fab', 'microsoft']"
                size="1x"
                :spin="processing === 'microsoft' ? true : false"
              />
            </span>
            Join with Microsoft
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'SignUp',
  components: {
  },
  data() {
    return {
      processing: '',
      emailFormType: 'signIn',
      autoLogin: false,
      signUpConfirmPasswordError: ''
    }
  },
  computed: {
    ...mapState('voter', [
      'formFields',
      'name',
      'email',
      'password',
      'confirmPassword',
      'birthday',
      'resetToken',
      'gameLogo',
      'optIn',
      'isOptInEnabled',
      'optInText',
      'externalToken',
      'authenticationMethods',
      'wasLoggedOut'
    ]),
    ...mapState('poll', [
      'group',
      'accountName',
      'pollGroupId'
    ]),
    ...mapGetters('voter', [
      'facebookSignInLink',
      'googleSignInLink',
      'microsoftSignInLink',
      'isAuthenticationEnabled'
    ]),
    formSubmitButtonText() {
      let text = 'Join with Email';
      switch(this.emailFormType) {
        case 'signUp':
          text = 'Sign Up';
          break;
        case 'passwordForgot':
          text = 'Submit';
          break;
        case 'passwordReset':
          text = 'Reset';
          break;
      }
      return text;
    },
    signUpName: {
      get() {
        return this.name;
      },
      set(value) {
        this.setName(value);
      }
    },
    signUpEmail: {
      get() {
        return this.email;
      },
      set(value) {
        this.setEmail(value);
      }
    },
    signUpPassword: {
      get() {
        return this.password;
      },
      set(value) {
        if (this.emailFormType === 'passwordReset') {
          if (this.signUpConfirmPassword){
            if (value !== this.signUpConfirmPassword) {
              this.signUpConfirmPasswordError = 'Passwords do not match!';
            } else {
              this.signUpConfirmPasswordError = '';
            }
          }
        }

        this.setPassword(value);
      }
    },
    signUpConfirmPassword: {
      get() {
        return this.confirmPassword;
      },
      set(value) {
        if (this.emailFormType !== 'passwordReset') {
          this.setConfirmPassword(value);
          return;
        }

        if (value !== this.signUpPassword) {
          this.signUpConfirmPasswordError = 'Passwords do not match!';
        } else {
          this.signUpConfirmPasswordError = '';
        }

        this.setConfirmPassword(value);
      }
    },
    signUpBirthday: {
      get() {
        return this.birthday;
      },
      set(value) {
        this.setBirthday(value);
      }
    },
    signUpOptIn: {
      get() {
        return this.optIn;
      },
      set(value) {
        this.setOptIn(value);
      }
    },
    nameLabel: function () {
      return this.group === 'bbl' ? `Enter the username <br> you entered in the prior step.` : 'Name';
    },
    haveMultipleAuthMethods() {
      let num = 0;
      for (const type in this.auth) {
        num += this.auth[type] ? 1 : 0
      }
      return num > 1;
    }
  },
  watch: {
    resetToken(token) {
      if (token) {
        this.emailFormType = 'passwordReset';
      }
    },
    autoLogin(autoLogin) {
      if (autoLogin) {
        this.emailSignUp()
        // todo: clean query params
      }
    }
  },
  methods: {
    ...mapMutations('voter', [
      'setRegistrationType',
      'setName',
      'setEmail',
      'setPassword',
      'setConfirmPassword',
      'setBirthday',
      'setOptIn',
      'setResetToken'
    ]),
    ...mapActions('voter', [
      'signup',
      'signin',
      'forgotPassword',
      'resetPassword',
      'getResetToken'
    ]),
    emailFormSubmit() {
      switch(this.emailFormType) {
        case 'signIn':
          if (this.authenticationMethods.passwordFree) {
            return this.emailSignUp();
          } else {
            return this.emailSignIn();
          }
        case 'signUp':
          return this.emailSignUp();
        case 'passwordForgot':
          return this.passwordForgot();
        case 'passwordReset':
          return this.passwordReset();
      }
    },
    async emailSignIn() {
      if (!this.$refs.signUpForm.reportValidity() || this.processing.length) {
        return;
      }
      this.processing = 'emailSignIn';
      try {
        await this.signin({
          email: this.signUpEmail.length ? this.signUpEmail : undefined,
          password: this.signUpPassword.length ? this.signUpPassword : undefined,
          accountName: this.accountName,
          ...(this.isOptInEnabled && {optIn: this.optIn})
        });
        this.processing = '';

        // Clean up resetToken from URL and store after successful login
        this.setResetToken('');
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.has('resetToken')) {
          currentUrl.searchParams.delete('resetToken');
          currentUrl.searchParams.delete('returnUrl');
          window.history.replaceState({}, '', currentUrl.toString());
        }

        window.parent.postMessage({
          auth: true
        }, '*');

        // Logout clears the poll group and the loaded poll, and an email login does not reload the page,
        // so reload to read them again from the URL (the session is kept in localStorage).
        if (this.wasLoggedOut) {
          window.location.reload();
        }
      } catch (e) {
        this.processing = '';
        Vue.notify({
          group: 'general',
          title: 'Sign In failed',
          type: 'error',
          text: e.message.replace(`${e.name}:`, ''),
          duration: 5000
        });
      }
    },
    generatePassword(length = 30) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()+_?><:}{|~,./;`[]-=';
      const setLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * setLength));
      }
      return result;
    },
    async emailSignUp() {
      const isValidForm = this.$refs.signUpForm.reportValidity() || this.autoLogin;
      if (this.processing.length || (this.authenticationMethods.passwordFree && !this.signUpEmail.length) || !isValidForm) {
        return;
      }
      this.processing = 'emailSignUp';
      try {
        await this.signup({
          name: this.authenticationMethods.passwordFree
            ? (this.signUpEmail?.split('@')[0] || 'Anonymous')
            : this.signUpName,
          email: this.signUpEmail.length ? this.signUpEmail : undefined,
          password: this.authenticationMethods.passwordFree ? this.generatePassword() : this.signUpPassword.length ? this.signUpPassword : undefined,
          birthday: this.authenticationMethods.passwordFree ? '1980-01-01' : this.signUpBirthday.length ? this.signUpBirthday : undefined,
          accountName: this.accountName,
          loginWithoutPass: this.authenticationMethods.passwordFree,
          ...(this.isOptInEnabled && {optIn: this.optIn})
        });
        this.processing = '';

        // Clean up resetToken from URL and store after successful signup
        this.setResetToken('');
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.has('resetToken')) {
          currentUrl.searchParams.delete('resetToken');
          currentUrl.searchParams.delete('returnUrl');
          window.history.replaceState({}, '', currentUrl.toString());
        }

        window.parent.postMessage({
          auth: true
        }, '*');

        // Logout clears the poll group and the loaded poll, and an email login does not reload the page,
        // so reload to read them again from the URL (the session is kept in localStorage).
        if (this.wasLoggedOut) {
          window.location.reload();
        }
      } catch (e) {
        this.processing = '';
        Vue.notify({
          group: 'general',
          title: 'Signup failed',
          type: 'error',
          text: e.message.replace(`${e.name}:`, ''),
          duration: 5000
        });
      }
    },
    async passwordForgot() {
      if (!this.$refs.signUpForm.reportValidity() || this.processing.length) {
        return;
      }
      this.processing = 'passwordForgot';
      try {
        await this.forgotPassword({
          email: this.signUpEmail.length ? this.signUpEmail : undefined,
          accountName: this.accountName,
          returnUrl: window.location.href,
          pollGroupId: this.currentPollGroupId()
        });
        this.processing = '';
        Vue.notify({
          group: 'general',
          title: 'Forgot Password',
          type: 'success',
          text: 'If you have signed up with this address, you will receive an email with further instructions',
          duration: 15000
        });
      } catch (e) {
        this.processing = '';
        Vue.notify({
          group: 'general',
          title: 'Forgot password failed',
          type: 'error',
          text: e.message.replace(`${e.name}:`, ''),
          duration: 5000
        });
      }
    },
    async passwordReset() {
      if (!this.$refs.signUpForm.checkValidity() || this.processing.length) {
        Vue.notify({
          group: 'general',
          title: 'Password reset failed',
          type: 'error',
          text: 'Password must be at least 8 characters and contain at least one symbol (!@#$%^&*=)',
          duration: 5000
        });
        return;
      }
      if (this.signUpPassword !== this.signUpConfirmPassword) {
        return;
      }
      this.processing = 'passwordReset';
      try {
        await this.resetPassword({
          password: this.signUpPassword,
          token: this.resetToken
        });
        this.processing = '';
        this.emailFormType = 'signIn';

        // Clear resetToken from Vuex store
        this.setResetToken('');

        // Get returnUrl from query params to redirect user back to original location
        const params = new URLSearchParams(window.location.search);
        let returnUrl = params.get('returnUrl');

        // Clean up resetToken and returnUrl from current URL
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('resetToken');
        currentUrl.searchParams.delete('returnUrl');
        window.history.replaceState({}, '', currentUrl.toString());

        // Clean up resetToken from returnUrl if it exists
        if (returnUrl) {
          try {
            const returnUrlObj = new URL(decodeURIComponent(returnUrl));
            returnUrlObj.searchParams.delete('resetToken');
            returnUrlObj.searchParams.delete('returnUrl');
            returnUrl = returnUrlObj.toString();
          } catch (e) {
            // If returnUrl is not a full URL, try to clean it as a relative path
            const urlMatch = returnUrl.match(/^([^?]+)(\?.*)?$/);
            if (urlMatch) {
              const baseUrl = urlMatch[1];
              const queryString = urlMatch[2] || '';
              const queryParams = new URLSearchParams(queryString);
              queryParams.delete('resetToken');
              queryParams.delete('returnUrl');
              const cleanQuery = queryParams.toString();
              returnUrl = baseUrl + (cleanQuery ? `?${cleanQuery}` : '');
            }
          }
        }

        Vue.notify({
          group: 'general',
          title: 'Reset Password',
          type: 'success',
          text: 'Your password has been reset, please login',
          duration: 15000
        });

        // Redirect to original URL if provided, otherwise stay on current page (now cleaned)
        if (returnUrl) {
          setTimeout(() => {
            window.location.href = returnUrl;
          }, 2000);
        }
      } catch (e) {
        this.processing = '';
        Vue.notify({
          group: 'general',
          title: 'Reset password failed',
          type: 'error',
          text: e.message.replace(`${e.name}:`, ''),
          duration: 5000
        });
      }
    },
    getSocialLink(provider) {
      const socialLinks = {
        facebook: this.facebookSignInLink,
        google: this.googleSignInLink,
        microsoft: this.microsoftSignInLink,
      };
      return socialLinks[provider];
    },
    // Logout clears pollGroupId from the store, but the URL (/pollGroups/<account>/pollgroup/<id>) still has it.
    currentPollGroupId() {
      if (this.pollGroupId) return this.pollGroupId;
      const parts = window.location.pathname.split('/').filter(Boolean);
      const i = parts.indexOf('pollGroups');
      return i > -1 && parts[i + 2] === 'pollgroup' ? parts[i + 3] : undefined;
    },
    socialLogin(provider) {
      this.processing = provider;
      let redirectLink = `${this.getSocialLink(provider)}?accountName=${this.accountName}`;
      const pollGroupId = this.currentPollGroupId();
      if (pollGroupId) redirectLink += `&pollGroupId=${pollGroupId}`;
      window.location.href = redirectLink;
    }
  },
  async mounted() {
    this.$refs.signUpName && this.$refs.signUpName.focus();
    await this.getResetToken();
    const queryParams = new URLSearchParams(window.location.search);
    const email = queryParams.get('email');
    const isValidEmail = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,}$/.test(email);

    if (email && !isValidEmail) {
      // remove email from query params
      const url = new URL(window.location.href);
      url.searchParams.delete('email');
      window.history.replaceState({}, '', url);
    }

    if (!this.authenticationMethods.passwordFree && email && isValidEmail) {
      Vue.notify({
          group: 'general',
          title: 'Failed to login',
          type: 'error',
          text: `Failed to log in with ${email} account due password free login is not enabled`,
          duration: 5000
      });
    }

    if (this.authenticationMethods.passwordFree && email && isValidEmail) {
      this.signUpEmail = email;
      this.autoLogin = true;

      // remove email from query params
      const url = new URL(window.location.href);
      url.searchParams.delete('email');
      window.history.replaceState({}, '', url);
    }
  }
}
</script>

<style scoped lang="scss">
section {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(255,255,255,1);
}

.form {
  position: relative;
  z-index: 1;
  width: 300px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

form {
  background: #fff;
  padding: 16px;
  border-radius: 5px;
  box-shadow: 0 4px 16px rgba(60, 40, 40, 0.12);
}

.notification {
  margin: 12px 0 0 0;
}

h4 {
  margin: 0;
  font-size: 20px;
  line-height: 1;
}

label {
  display: block;
  color: rgba(47, 49, 56, 0.35);
  font-size: 12px;
  margin: 12px 0 2px;
}

input {
  display: block;
  background: #fff;
  border: 1px solid #c8cbd2;
  font-size: 16px;
  font-family: inherit;
  box-shadow: 0px 6px 12px 0px rgba(95, 103, 109, 0.09);
  display: block;
  width: 100%;
  padding: 12px 15px;
  height: 40px;
  box-sizing: border-box;
  transition: box-shadow .25s ease-out,
  border-color .2s;

  @media only screen and (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }

  &::placeholder,
  &::-webkit-input-placeholder,
  :-ms-input-placeholder {
    color: rgb(47,49,56);
  }

  &:focus {
    outline: none;
    border: 1px solid #929aad;
  }
}

.error-message {
  color: #FF0000;
  font-size: 12px;
  margin-top: 12px;
}

button {
  position: relative;
  margin: 14px 0 0 0;
  width: 100%;
  font-size: 16px;
  font-family: inherit;
  text-align: center;
  height: 40px;
  padding: 0 15px;
  color: #fff;
  box-sizing: border-box;
  border: 0;
  background: #2bbd7e;
  cursor: pointer;

  &.email {
    background: #E8E9EB;
    color: #000;
  }

  &.google {
    background: #EA4335;
  }

  &.facebook {
    background: #3b5998;
  }

  &.microsoft {
    background: #00a1f1;
  }

  .spinner {
    position: relative;
    left: -24px;
    width: 20px;
    margin: 0 -20px 0 0;
  }

  .icon {
    position: absolute;
    left: 15px;
  }

  &:disabled {
    cursor: not-allowed;
    background: #808080;
    color: #fff;
  }
}

.sign-up-enter-active, .sign-up-leave-active {
  transition: all 750ms cubic-bezier(0.230, 1.000, 0.320, 1.000);

  form {
    transition: all 750ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  }
}

.sign-up-leave-to {
  opacity: 0;

  form {
    transform: scale(0.9);
  }
}

.sign-up-enter {
  form {
    transform: scale(0.9);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: all 250ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.style-bbl {

  section {
    z-index: 1000;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
  }

  .bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #102B50;
    background-image: url('../assets/nextgen/ford-gameplay-bg.png');
    z-index: 0;
    background-repeat: no-repeat;
    background-size: cover;
  }

  button {
    background: #1887D6;
    font-weight: 700;
    padding: 14px;
    height: auto;

    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: -0.41px;
    text-align: center;
    line-height: 1.3125;

    transition: background 250ms ease-out;

    @media only screen and (min-width: 1140px) {
      font-size: 24px;
    }

    &:hover {
      background: rgba(24, 135, 214, 0.8);
    }

    &:disabled {
      background: rgba(24, 135, 214, 0.5);
    }
  }

  .form {
    min-height: 100%;
    padding: 20px 0;
    width: auto;

    .img {
      flex: 0 1 187px;
      width: 100%;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: auto 100%;
      background-image: url('../assets/nextgen/ford-gameday.png');

      @media only screen and (min-width: 1140px) {
        flex: 0 1 300px;
      }
    }
  }

  form {
    padding: 0 20px;
    width: 380px;
    max-width: 100%;
    background: none;
    box-shadow: inherit;
    border-radius: inherit;

    @media only screen and (min-width: 1140px) {
      width: 580px;
    }
  }

  input {
    background: rgba(4,30,50,0.35);
    border: 1px solid #68BCF5;
    padding: 14px;
    margin-top: 12px;
    height: auto;

    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: -0.41px;
    line-height: 1.3125;
    text-align: left;
    box-sizing: border-box;

    transition: border 250ms ease-out;

    @media only screen and (min-width: 1140px) {
      font-size: 24px;
    }

    &:hover,
    &:focus {
      border-color: rgba(24, 135, 214, 0.8);
    }
  }

  h2 {
    font-size: 28px;
    color: #FFFFFF;
    letter-spacing: -0.72px;
    text-align: center;
    font-weight: 700;
    margin-top: 20px;

    @media only screen and (min-width: 1140px) {
      font-size: 42px;
    }

    span {
      white-space: nowrap;
    }
  }

  label {
    font-size: 16px;
    color: #FFFFFF;
    font-weight: 400;
    letter-spacing: -0.41px;
    text-align: center;
    line-height: 1.3125;
    margin-top: 20px;

    @media only screen and (min-width: 1140px) {
      font-size: 24px;
    }
  }
}

.game-logo {
  max-height: 80px;
  margin-bottom: 20px;
}

.optIn {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  label {
    color: #c8cbd2;
    font-size: 16px;
    color: rgb(47,49,56);
  }

  input {
    width: 10%;
    height: 15px;
    margin-top: 13px;
  }
}
</style>
